import { DatePickerView } from '@mui/lab/DatePicker/shared';
import { DateTime } from 'luxon';
import { ForeignStateVM } from 'shell/components/shared/foreign-state-list';
import { MunicipalityAnprVM } from 'shell/components/shared/municipality-list';
import { EventDatas } from 'shell/models/person/shared';
import { DocumentDigital } from 'shell/view-models/act-form';
import { transformDocumentDigital } from './shared/transform-document-digital';

type EventLocationVM = {
  exceptionalLocation?: string;
  municipality?: MunicipalityAnprVM | null;
  foreignState?: ForeignStateVM | null;
  localita: string;
};

export interface EventDataVM {
  isForeign?: boolean;
  eventDate?: DateTime | null;
  eventChoiceDate?: Array<DatePickerView>;
  exceptionalLocation?: string;
  municipality?: MunicipalityAnprVM | null;
  year?: string;
  province?: string;
  documentNumber?: string;
  portion?: string;
  range?: string;
  regVol?: string;
  office?: string;
  documentDate?: DateTime | null;
  transcript?: boolean;
  location?: EventLocationVM;
  digital?: DocumentDigital;
}

export const transformEventData = (values: EventDataVM | undefined): EventDatas | undefined => {
  const hasEventLocation =
    values?.location?.exceptionalLocation ||
    values?.location?.municipality?.description ||
    values?.location?.foreignState?.id;

  const withActPaper =
    values?.office ||
    values?.year ||
    values?.portion ||
    values?.range ||
    values?.documentNumber ||
    values?.regVol ||
    values?.documentDate ||
    values?.municipality?.description ||
    values?.municipality?.id ||
    values?.municipality?.province;

  const withActDigital = Boolean(values?.digital);

  const returnData: EventDatas | undefined =
    withActPaper || withActDigital || values?.eventDate || hasEventLocation
      ? {
          dataEvento: values?.eventDate?.toFormat('yyyy-MM-dd') || undefined,
          senzaGiorno:
            !values?.eventChoiceDate?.includes('day') &&
            values?.eventChoiceDate?.includes('month') &&
            values?.eventDate
              ? '1'
              : undefined,
          senzaGiornoMese:
            !values?.eventChoiceDate?.includes('day') &&
            !values?.eventChoiceDate?.includes('month') &&
            values?.eventChoiceDate?.includes('year') &&
            values?.eventDate
              ? '1'
              : undefined,
          luogoEvento: hasEventLocation
            ? {
                luogoEccezionale: values?.location?.exceptionalLocation || undefined,
                comune: values?.location?.municipality?.description
                  ? {
                      nomeComune: values?.location?.municipality?.description || undefined,
                      codiceIstat: values?.location?.municipality?.id || undefined,
                      siglaProvinciaIstat: values?.location?.municipality?.province || undefined,
                      descrizioneLocalita: values?.location?.localita || undefined,
                    }
                  : undefined,
                localita: values?.location?.foreignState?.id
                  ? {
                      descrizioneLocalita: values?.location?.localita || undefined,
                      descrizioneStato: values?.location?.foreignState?.value || undefined,
                      codiceStato: values?.location?.foreignState?.id || undefined,
                      provinciaContea: values?.location?.foreignState?.province || undefined,
                    }
                  : undefined,
              }
            : undefined,

          attoEventoANPR:
            withActPaper || withActDigital
              ? {
                  atto: withActPaper
                    ? {
                        ufficioMunicipio: values?.office || undefined,
                        anno: values?.year || undefined,
                        parte: values?.portion || undefined,
                        serie: values?.range || undefined,
                        numeroAtto: values?.documentNumber || undefined,
                        volume: values?.regVol || undefined,
                        dataFormazioneAtto:
                          values?.documentDate?.toFormat('yyyy-MM-dd') || undefined,
                        trascritto: values?.transcript ? '1' : undefined,
                        comuneRegistrazione: values?.municipality
                          ? {
                              nomeComune: values?.municipality?.description || undefined,
                              codiceIstat: values?.municipality?.id || undefined,
                              siglaProvinciaIstat: values?.municipality?.province || undefined,
                            }
                          : undefined,
                      }
                    : undefined,
                  attoANSC: withActDigital ? transformDocumentDigital(values?.digital) : undefined,
                }
              : undefined,
        }
      : undefined;

  return returnData;
};
